import { useState, useEffect } from "react";

const useTrackCommentForm = (initialFormValues, callback, validate) => {
  const [inputs, setInputs] = useState(initialFormValues);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback();
    }
  }, [errors]);

  const handleInputChange = (event) => {
    event.persist();
    setInputs((inputs) => ({ ...inputs, [event.target.name]: event.target.value }));
  };

  const insertHtml = (makeHtml, { append = false } = {}) => {
    const textarea = document.getElementById("quoteComment");
    const comment = textarea ? textarea.value : "";
    const start = append || !textarea ? comment.length : textarea.selectionStart;
    const end = append || !textarea ? comment.length : textarea.selectionEnd;
    const selected = comment.slice(start, end);
    const insertion = makeHtml(selected);
    const spacer = append && comment && !comment.endsWith(" ") ? " " : "";
    const next = comment.slice(0, start) + spacer + insertion + comment.slice(end);
    const placeholder = "ADD_YOUR_URL_HERE";
    const placeholderAt = insertion.indexOf(placeholder);
    const selectFrom = start + spacer.length + (placeholderAt >= 0 ? placeholderAt : insertion.length);
    const selectTo = placeholderAt >= 0 ? selectFrom + placeholder.length : selectFrom;

    setInputs((current) => ({ ...current, quoteComment: next }));
    requestAnimationFrame(() => {
      if (!textarea) return;
      textarea.focus();
      textarea.setSelectionRange(selectFrom, selectTo);
    });
  };

  const insertLinkTag = () => {
    insertHtml((selected) => `<a href="ADD_YOUR_URL_HERE" target="_blank">${selected}</a>`);
  };

  const insertImageTag = () => {
    insertHtml(() => `<img src="ADD_YOUR_URL_HERE" class="img-responsive" border="0" />`, { append: true });
  };

  const clearForm = () => {
    setInputs(initialFormValues);
  };

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    setErrors(validate(inputs));
    setIsSubmitting(true);
  };

  return {
    handleInputChange,
    handleSubmit,
    insertLinkTag,
    insertImageTag,
    inputs,
    clearForm,
    errors,
  };
};

export default useTrackCommentForm;
